"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
const utils_1 = require("../utils");
const endpoint_1 = require("../endpoint/endpoint");
const base = '/auth';
const signin = (payload) => {
    const url = (0, utils_1.urlFactory)(base, `/signin`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, payload });
};
const signup = (payload) => {
    const url = (0, utils_1.urlFactory)(base, `/signup`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, payload });
};
const signout = () => {
    const url = (0, utils_1.urlFactory)(base, `/signout`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' } });
};
const refreshToken = () => {
    const url = (0, utils_1.urlFactory)(base, `/refresh-token`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' } });
};
const current = (options) => {
    const url = (0, utils_1.urlFactory)(base, `/currentuser`);
    return new endpoint_1.Endpoint({ url, init: { method: 'GET' }, options });
};
const forgotPassword = (payload) => {
    const url = (0, utils_1.urlFactory)(base, `/forgot-password`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, payload });
};
const resetPassword = (payload) => {
    const url = (0, utils_1.urlFactory)(base, `/reset-password`);
    return new endpoint_1.Endpoint({ url, init: { method: 'POST' }, payload });
};
exports.auth = {
    signin,
    signup,
    signout,
    refreshToken,
    current,
    forgotPassword,
    resetPassword
};
